window.PHBrain = {
  version: "1.2.0",

  perfumes: window.PHKnowledge || [],

  occasions: {
    cita: ["cita"],
    oficina: ["oficina"],
    playa: ["playa"],
    elegante: ["elegante"],
    diario: ["diario"],
    noche: ["noche"]
  },

  rules: {},

  recommend(options = {}) {
    const {
      gender = null,
      occasion = null,
      climate = null,
      family = null,
      limit = 6
    } = options;

    let results = [...this.perfumes];

    if (gender) {
      results = results.filter(p => p.gender === gender || p.gender === "unisex");
    }

    if (occasion) {
      results = results.filter(p => p.occasions.includes(occasion));
    }

    if (climate) {
      results = results.filter(p => p.climate.includes(climate));
    }

    if (family) {
      results = results.filter(p => p.family.includes(family));
    }

    return results
      .sort((a, b) => b.score - a.score)
      .slice(0, limit);
  }
};